var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-plyr',{attrs:{"options":_vm.options}},[_c('audio',{attrs:{"controls":"","crossorigin":"","playsinline":""}},[_c('source',{attrs:{"src":_vm.audio.src,"type":_vm.audio.mime_type}})])])}
var staticRenderFns = []

export { render, staticRenderFns }